import * as diacritics from "diacritics";
import slugify from "slugify";
import _ from "./lodash";
var removeDiacritics = diacritics.remove;
export var replaceApostrophes = function (str) { return (str || "").replace(/[’ʻʼ]/g, "-"); };
export var stripAccents = function (str) {
    var reAccents = /[αàáâãäçəèéêëìíîi̇ïñòóôõöùúūûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎİÏÑÒÓÔÕÖÙÚÛÜÝЎʻʼ]/g;
    var replacements = "[aaaaaaceeeeeiiiiiinooooouuuuuyyAAAAACEEEEIIIIINOOOOOUUUUYY'']";
    return str.replace(reAccents, function (match) { return replacements[reAccents.source.indexOf(match)]; });
};
export var cleanString = _.flow([
    replaceApostrophes,
    _.kebabCase,
    stripAccents,
    removeDiacritics,
    slugify,
]);



//////////////////
// WEBPACK FOOTER
// ./app/shared/utils/string.ts
// module id = bwFx
// module chunks = 2